// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__phbBq","shimmer":"styles_shimmer__fBeEk"};